import React from 'react';

import FarmProductionRecordAddForm from './FarmProductionRecordAddForm';

export default function FarmProductionRecordAddHarvestScreen() {
  return (
    <FarmProductionRecordAddForm
      type="HARVEST"
      title="Add Harvesting Records"
      successMessage="Create Harvesting Record successfully"
    />
  );
}
